<template>
  <section class="home">
    <za-banner></za-banner>
    <div class="wrap">
      <h2 class="linkus">虚拟大师介绍</h2>
      <div class="desc">
        <p>虚拟大师是一款真正的移动设备上的虚拟机（Virtual Machine），轻松实现手机里面双系统的同时运行，一部手机可以当两部手机使用。</p>
        <p>应用启动后，您需要下载一个100MB左右的Android系统（Android AOSP的标准系统），类似于PC上的VMWare，OS in OS，将第二个手机系统以普通应用的形式安装到任何安卓版本的手机或移动设备上，一键切换，非常实用。用户可以在本机系统和虚拟系统之间自由切换运行的应用或游戏，游戏即使退到后台后也可以在独立的虚拟窗口里运行。</p>
        <p>虚拟大师，一键切换手机双系统，比云手机更极致流畅！独立封闭的虚拟环境，更安全。独有内存管理机制，全球领先的引擎，完美极致的性能，深受安卓用户的喜爱。</p>
        <p>1. 只需要安装一个App，即可实现手机双系统同时运行，体验不同安卓系统带来的乐趣！</p>
        <p>2. 独立系统虚拟显卡，支持游戏/应用后台运行，不影响前台操作，手机来电、息屏也不掉线；</p>
        <p>3. 独立运行的安卓虚拟系统，还可以支多种Android版本，满足多种APP应用、游戏的系统运行需求，支持多个账号同时在线；</p>
        <p>如果您在使用过程中遇到任何问题，请联系官方QQ群：790075253。</p>
      </div>
      <h2 class="linkus">公司介绍</h2>
      <div class="desc">
        上海熠强网络科技有限公司是一家快速成长型移动互联网企业，主创团队来自“上海软件企业百强”之一，曾参与40余项产品开发/运营，为数亿用户提供优质服务，PC/APP/H5端运营经验丰富，科研实力雄厚。现有团队成员以90后为主，以工具类产品为切入口，致力于为用户提供更具价值的互联网产品。在以技术为驱动，行业资源强强联动的助推下，熠强科技正在以突破性的速度取得市场瞩目。 
      </div>
    </div>
  </section>
</template>

<script>
import zaBanner  from '@/components/Banner.vue'
export default {
  components: {
    zaBanner
  },
  data () {
    return {
      reportsList: [{
        title: '中国网络文学版权保护研究报告',
        desc: '基于中国网络文学正版化进程迈入发展新阶段的时代背景，在梳理中国网络文学行业发展脉络的同时，以行业整体视角回顾......'
      }, {
        title: '移动互联网虚拟化技术发展报告',
        desc: '基于移动互联网虚拟化技术与PC端联合对比，跟踪虚拟化技术的发展趋势与历史沿革，从横纵向的角度，梳理了虚拟化技术......'
      }, {
        title: '中国互动娱乐季度数据发布研究报告',
        desc: '基于多年游戏行业研究、数据积累以及市面产品监测成果，通过对娱乐应用类型、题材、IP等各个因素的分析，从技术、市.......'
      }, {
        title: '中国移动营销行业洞察报告',
        desc: '按照营销产业链的维度划分，参与营销的企业主要有广告主、营销供应商、媒体三大类型。广告主作为产业链的开端和需求......'
      }]
    }
  }
}
</script>
<style scoped>
.article {
  width: 1200px;
  margin: 0 auto;
  padding: 50px 0 130px; 
}
.article-title {
  font-size: 36px;
  text-align: center;
}
.article-inner {
  padding: 65px 88px;
  font-size: 18px;
  overflow: auto;
}
.article-item {
  width: 202px;
  float: left;
  margin-right: 72px;
}
.article-item:nth-child(4n) {
  margin-right: 0;
}
.article-item-cover {
  width: 202px;
  height: 160px;
  padding: 12px;
  color: rgba(255, 255, 255, .7);
  background-image: url('../assets/cardBg.png');
}
.article-item-title {
  width: 180px;
  margin: 20px auto;
  text-align: center;
  color: #000;
}
.article-item-desc {
  font-size: 14px;
  line-height: 30px;
  color: #333;
}
.more-link {
  text-align: center;
}
.more-link a {
  font-size: 18px;
  height: 27px;
  line-height: 27px;
  display: inline-block;
  color: #016091;
  padding-bottom: 1px;
}
.more-link a:hover {
  border-bottom: 1px solid #016091;
}
.more-link a span {
  font-weight: 700;
}
.wrap {
  width: 1020px;
  margin:0 auto;
  padding: 20px;
}
.linkus {
  font-size: 22px;
  font-weight: 600;
  color:#333;
  margin:30px 0;
}
.desc {
  font-size: 18px;
  color: #333;
}
</style>